import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { approveOrderReq, getOrderDetails, getVendorOrders, rejectOrderReq } from "../../../../modules/VendorModule/Services/VendorApprovalService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { Key } from "@mui/icons-material";

const formatProperties = ["freightCost", "tax", "unitPrice", "subtotal", "total_cost"];
const propMap = {discount: x => (["number", "string"].includes(typeof(x))) ? `${x}%`: x}

const detailMapper = (d) => ({...d, ...Object.entries(d).reduce((acc, [key, value]) => ({...acc, [`fmt_${key}`]: formatProperties.includes(key) ? ((typeof(value) === 'number') ? value.toLocaleString() : value) :((key in propMap) ? propMap[key](value) :value)}), {})})
// const detailMapper = (d) => ({...Object.entries(d).reduce((acc, [key, value]) => ({...acc, [`fmt_${key}`]:( formatProperties.includes(key) ? ("Hola Mundo") : ("Bye Mundo"))}), {})})

const mockData = [
    { id: 0, orderType: "PO", status: "STV", orderNumber: "202508001", location: "MIA", site: "Warehouse 01", dateRequired: "2025-07-23", priority: "Medium", requestedBy: "Spirit Airlines", supplyChain: "9876542123", created: "2025-07-01", daysSince: "44", totalCost: "$1,500.00 USD" },

    {
        id: 1,
        orderType: "RO",
        status: "STV",
        orderNumber: "202508002",
        location: "LAX",
        site: "Receiving Dock A",
        dateRequired: "2025-07-25",
        priority: "High",
        requestedBy: "Delta Cargo",
        supplyChain: "1234567890",
        created: "2025-07-02",
        daysSince: "43",
        totalCost: "$2,750.00 USD"
    },
    {
        id: 2,
        orderType: "LO",
        status: "STV",
        orderNumber: "202508003",
        location: "JFK",
        site: "Logistics Hub 3",
        dateRequired: "2025-07-26",
        priority: "Low",
        requestedBy: "American Airlines",
        supplyChain: "4567891230",
        created: "2025-07-03",
        daysSince: "42",
        totalCost: "$980.00 USD"
    },
    {
        id: 3,
        orderType: "SO",
        status: "STV",
        orderNumber: "202508004",
        location: "ORD",
        site: "Outbound Bay 2",
        dateRequired: "2025-07-27",
        priority: "Medium",
        requestedBy: "United Express",
        supplyChain: "7890123456",
        created: "2025-07-04",
        daysSince: "41",
        totalCost: "$1,200.00 USD"
    },
    {
        id: 4,
        orderType: "PO",
        status: "STV",
        orderNumber: "202508005",
        location: "ATL",
        site: "Warehouse 02",
        dateRequired: "2025-07-28",
        priority: "High",
        requestedBy: "JetBlue Logistics",
        supplyChain: "3216549870",
        created: "2025-07-05",
        daysSince: "40",
        totalCost: "$3,100.00 USD"
    },
    {
        id: 5,
        orderType: "RO",
        status: "STV",
        orderNumber: "202508006",
        location: "SEA",
        site: "Receiving Dock B",
        dateRequired: "2025-07-29",
        priority: "Medium",
        requestedBy: "Alaska Air",
        supplyChain: "6543217890",
        created: "2025-07-06",
        daysSince: "39",
        totalCost: "$1,850.00 USD"
    }

];

const VendorApprovalSlice = createSlice({
    name: "vendorApproval",
    initialState: {
        orders: [],
        details: {},
        status: {},
        search: "",
        orderBy: "",
        page: 0,
        totalPages:1,
        loading: false,

    },
    reducers: {
        updateOrder: (state, action) => {
            return { ...state }
        },
        updateSearch: (state, action) => {
            let { search } = action.payload;
            return { ...state, search, page: 0 };
        },
        updateOrderBy: (state, action) => {
            let { orderBy } = action.payload;
            return { ...state, orderBy, page: 0 };
        },
        nextPage: (state, action) => {
            return { ...state, page: state.page + 1 };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchOrders.pending, (state, action) => {
            return {...state, loading:true};
        });
        builder.addCase(fetchOrders.fulfilled, (state, action) => {
            let { orders, totalPages } = action.payload;
            let mapped = orders.map(o => ({ ...o, createdDate: o.createdDate.slice(0, 10), totalCostMapped: `$${o.totalCost.toLocaleString()} ${o.currency}` }));
            return { 
                ...state, 
                totalPages, 
                orders: state.page>0 ? [...state.orders, mapped] : mapped, 
                status: { ...state.status, ...orders.reduce((prev, curr) => ({ ...prev, [curr.id]: curr.status }), {}) } 
            };
            // return {...state, orders: };
        });
        builder.addCase(fetchOrderDetails.fulfilled, (state, action) => {
            let { details, orderId } = action.payload;
            return { ...state, details: { ...state.details, [orderId]: details.map(detailMapper) } };
        });
        builder.addCase(approveOrder.fulfilled, (state, action) => {
            let { orderId, orderIdx } = action.payload;
            return { ...state, status: { ...state.status, [orderId]: "Vendor Approved" } }
        })
        builder.addCase(rejectOrder.fulfilled, (state, action) => {
            let { orderId } = action.payload;
            return { ...state, status: { ...state.status, [orderId]: "Cancelled" } }
        });
    }
});

export const approveOrder = createAsyncThunk("vendorApproval/approveOrder",
    async ({ orderId, orderIdx }, { getState, rejectWithValue }) => {
        let response = await approveOrderReq(orderId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { orderId, orderIdx };
        } else {
            return rejectWithValue(null);
        }

    }
)
export const rejectOrder = createAsyncThunk("vendorApproval/rejectOrder",
    async ({ orderId, reason }, { getState, rejectWithValue, }) => {
        let response = await rejectOrderReq(orderId, reason);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { orderId };
        } else {
            return rejectWithValue(null);
        }

    }
)

export const fetchOrders = createAsyncThunk("vendorApproval/fetchOrders",
    async ({ companyId, search, page, orderBy }, { getState, rejectWithValue }) => {
        console.warn(companyId);
        let response = await getVendorOrders(companyId, search, page, orderBy);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            console.warn('success orders retrieval', response.data.load);
            return { orders: response.data.load, totalPages: response.data.totalPages };
        }
        return rejectWithValue(null);
    }
)

export const fetchOrderDetails = createAsyncThunk("vendorApproval/fetchOrderDetails",
    async ({ orderId, companyId }, { getState, rejectWithValue }) => {
        let response = await getOrderDetails(orderId, companyId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { details: response.data.load, orderId }
        } else {
            return rejectWithValue(null);
        }
    }
)

export const { updateOrder, updateSearch, updateOrderBy, nextPage } = VendorApprovalSlice.actions;
export const selectVendorOrders = (state) => state.vendorApproval.orders;
export const selectDetails = (state) => state.vendorApproval.details;
export const selectStatus = (state) => state.vendorApproval.status;
export const selectVAppSearch = (state) => state.vendorApproval.search;
export const selectVAppOrderBy = (state) => state.vendorApproval.orderBy;
export const selectVAppPage = (state) => state.vendorApproval.page;
export const selectVAppTotalPages = (state) => state.vendorApproval.totalPages;
export const selectVAppLoading = (state) => state.vendorApproval.loading;
export default VendorApprovalSlice.reducer;